module.exports = __webpack_public_path__ + "static/media/privacyPolicyPWA.b755a676.md";